module.exports = __webpack_public_path__ + "a640a5a1c43fb070befd037c0260080f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/dragon-poster.png
// module id = 1000
// module chunks = 0